module.exports = __webpack_public_path__ + "static/media/pdf.4cf47574.png";